export enum InvoiceType {
  MEDIATION = 'MEDIATION',
  PENALTY = 'PENALTY',
  CREDIT_NOTE = 'CREDIT_NOTE',
  EXTRA_PACKAGE = 'EXTRA_PACKAGE',
}
